import React, { useState } from 'react';
import { getApi } from '../../api/endpoints.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingComponent from '../../components/ListingComponent.js';
import { useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const Index = () => {
  const defaultHeaderConfig = { disableSort: true };
  const params = useParams();
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Document Type',
      attr: 'doc_type',
    },
    {
      ...defaultHeaderConfig,
      label: 'File',
      value: (row) => {
        return <div style={{cursor: 'pointer'}}>
          {row.url &&  <a target="_blank" href={row.url}>
            <FontAwesomeIcon icon={faDownload}/>
          </a>}
        </div>
      },
    }
  ]

  // params = () => {

  // }
  return <ListingComponent
    key={"PAGES.EarningsListingPage.name"}
    breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Documents' }]}
    listingMutation={getApi('user_documents')}
    className="user-documents-page"
    contentHeading="Documents - Results"
    headers={headers}
    recordsKey="documents"
    params= {{id: params.id}}
    searchBy={['ID']}
  />
};

export default Index;

